/**
 * Utility functions for formatting data
 */

/**
 * Format price in crystals with Russian locale formatting (spaces for thousands)
 * @param {number|string} price - Price in crystals
 * @returns {string} Formatted price string (e.g., "6 300", "1 250 000")
 */
export const formatPrice = (price) => {
  return Number(price).toLocaleString('ru-RU')
}

/**
 * Format number with locale string (adds commas for thousands)
 * @param {number} number - Number to format
 * @returns {string} Formatted number string
 */
export const formatNumber = (number) => {
  return number.toLocaleString()
}
